import SettingBase from '../settings/util/SettingBase'

class RouteProgressController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, SetupService, RouteService, $q, DateUtil, RouteProgressService, $rootScope, DataCounter, Navigation, CommonLayoutService,TimezoneList, $window) {
        this.$state = $state;
        this.User = User;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.RouteProgressService = RouteProgressService;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;
        this.CommonLayoutService = CommonLayoutService;
        this.$window = $window;
        this.TimezoneList = TimezoneList;

        this.model = {
            vaultDate: '',
            allRoutes: [],
            branch: this.User.getUser().branchId,
            route: null,
            routeStops: [],
            estimatedRouteMilage: {},
            routeDetails: {},
            sortColumn: "_index",
            reverseSort: false,
            estimatedRouteMilageLoading: false,
            estimatedRouteMilageError: null,
            timezone: null,
            timezoneList: this.TimezoneList.getTimezoneList(),
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        }

        this.colorMapping = {
            DO: 'green',
            CANT: 'red',
            PENDING: 'orange',
            PARTIAL: 'orange',
            NO_PICKUP: 'red',
            DELIVERED_NO_PICKUP: 'red',
            NOT: 'red'
        }

        this.mapMarkerFilters = [
            {
                label: this.$translate.instant('routeProgress.completed'),
                value: ['DO'],
                isChecked: true
            },
            {
                label: this.$translate.instant("routeProgress.cant"),
                value: ['CANT'],
                isChecked: true
            },
            {
                label: this.$translate.instant('routeProgress.pending'),
                value: ['PENDING', null],
                isChecked: true
            },
            {
                label: this.$translate.instant('routeProgress.no_pickup'),
                value: ['NO_PICKUP'],
                isChecked: true
            },
            {
                label: this.$translate.instant('routeProgress.completed_no_pickup'),
                value: ['DELIVERED_NO_PICKUP'],
                isChecked: true
            },
            {
                label: this.$translate.instant('atm_residual.crv'),
                value: ['CRV'],
                isChecked: true
            },
            {
                label: this.$translate.instant('routeProgress.not_worked'),
                value: ['NOT'],
                isChecked: true
            },
            // {
            //     label: this.$translate.instant('routeProgress.sequence'),
            //     value: [null],
            //     isChecked: true
            // }
        ];
        this.totalRecord = 0;
        this.markerPosition = [];
        this.isInitialized = true;
        this.stackData = [];
        this.branchInfo = '';
        this.routeDataObj = {};
        this.$rootScope.$broadcast('routeChange', '/app/route-progress');
    }

    loadImage(image) {
        this.icon = {
            'REGULAR': 'regular.png',
            'ATM': 'atm.png',
            'BANK': 'bank.png',
            'NO_SHIP_NO_GO': 'nsng.png',
            'INTERNAL': 'internal.png',
            'TRUCK': 'truck.png',
            'TANKER': 'tanker.png',
            'WINDOW': 'window.png',
            'CARRIER': 'carrier.png',
            'ON_CALL': 'oncall.png',
            'LOCKER': 'locker.png',
            'VAULT': 'vault.png',
            'DELIVERY': 'delivery.png'
        }

        let imgURL = this.icon[image]
        return require('../../assets/images/' + imgURL);
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.branch)
        ])
            .then((data) => {
                this.routeDataObj = this.DataCounter.getData();
                this.branchInfo = data[0];
                this.model.timezone = this.model.timezoneList.find(timezone => timezone.value === moment.tz.guess()).value;
                const branchVaultDate = (this.routeDataObj && this.routeDataObj.isRedirected) ? this.routeDataObj.vaultDate : data[0].currentVaultDate;
                const date = this.DateUtil.convertToDate(branchVaultDate);
                this.model.date = date;
                this.vaultDate = moment(this.model.date).format('YYYY-MM-DD');
                this.minVaultDate = {
                    maxDate: this.vaultDate
                }
            })
            .then(() => {
                this.loadRoutes().then(() => this.autoSetAndLoadData());
                // this.loadMap();
            })
    }

    loadMap(routeSequenceData) {
        this.routePosition = 0;
        this.centerLattitude = this.lat / this.totalLatLongLocations || 39.68649209557518;
        this.centerLongitude = this.long / this.totalLatLongLocations || -101.48273981764913;
        this.mapMarkerFilters.forEach((obj) => obj.isChecked = true)
        if (this.isInitialized) {
            this.map = L.map('map', {
                // center: [this.centerLattitude, this.centerLongitude],
                // zoom: 11
            });

            let fallbackLatLong = [this.branchInfo.gpsLat, this.branchInfo.gpsLong];
            if (this.stopsInfo) {
                const truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
                const userCoordinatesInfo = this.stopsInfo.userCoordinatesInfo ? (this.stopsInfo.userCoordinatesInfo[0] || {}) : {};
                if (truckCoordinatesInfo.lat && truckCoordinatesInfo.long) {
                    fallbackLatLong = [truckCoordinatesInfo.lat, truckCoordinatesInfo.long];
                } else if (userCoordinatesInfo.lat && userCoordinatesInfo.long && (!userCoordinatesInfo.userOrigin || userCoordinatesInfo.userOrigin === 'USER')) {
                    fallbackLatLong = [userCoordinatesInfo.lat, userCoordinatesInfo.long];
                }
            }
            this.map.fitBounds(this.locationLatLong.length ? this.locationLatLong : [fallbackLatLong]);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        this.manageMarkers();
    }

    manageMarkers(i) {
        let activeMarkers = [], cursor = 0;

        if (i >= 0 && this.mapMarkerFilters[i]) {
            this.mapMarkerFilters[i].isChecked = !this.mapMarkerFilters[i].isChecked
        }
        if (this.markerPosition && this.markerPosition.length) {
            this.markerPosition.forEach((marker) => {
                this.map.removeLayer(marker);
            })
        }

        this.mapMarkerFilters.forEach((obj) => { if (obj.isChecked) activeMarkers = activeMarkers.concat(obj.value) });
        this.model.routeStops.forEach((sequenceData, index) => {
            if (sequenceData && sequenceData.lat && sequenceData.long && activeMarkers.indexOf(sequenceData.stopStatus) >= 0) {
                // this.routePosition = _.findIndex(routeSequenceData, { locationId: sequenceData.locationId }) + 1;
                this.markerColor = sequenceData.stopStatus ? this.colorMapping[sequenceData.stopStatus] : 'blue'
                this.actualLat = sequenceData.lat;
                this.actualLong = sequenceData.long;

                this.locationInfo = '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip +
                    '<br>' + sequenceData.city + ', ' + sequenceData.state;
                if (sequenceData.completedTime) this.locationInfo = this.locationInfo.concat(', ', '<br>', '<strong>', moment(sequenceData.completedTime).format('YYYY-MM-DD hh:mm a'), '</strong>');
                const id = L.marker([this.actualLat, this.actualLong],
                    {
                        icon: new L.AwesomeNumberMarkers({
                            // number: index + 1,
                            number: sequenceData.routeSeq = sequenceData._index, //=== -1 ? 'ST' : sequenceData.routeSeq,
                            markerColor: this.markerColor
                        })
                    })
                    .addTo(this.map)
                    .bindPopup(this.locationInfo)

                id.on('mouseover', function () {
                    id.openPopup();
                });

                id.on('mouseout', function () {
                    id.closePopup();
                });

                this.markerPosition.push(id);
            }
        })

        const waypoints = this.model.coordinates.map(c => L.latLng(c.latlng));
        L.polyline(waypoints, { color: "#40826D" }).addTo(this.map);

        function createArrowIcon(degree) {
            return L.divIcon({
                className: 'custom-icon',
                html: '<div style="transform: rotate(' + degree + 'deg);"><img src="../../assets/images/direction.png" class="direction-icon" /></div>',
                iconSize: [22, 22],
                iconAnchor: [11, 11],
            });
        }

        this.model.coordinates.forEach(point => {
            if (!point.direction || point.direction == -1) return;
            cursor++;
            const latLng = point.latlng;
            const arrowMarker = L.marker(latLng, { icon: createArrowIcon(point.direction) });
            arrowMarker.addTo(this.map);
        });
        
        if (cursor === 0) {
            const someFeatures = [];

            this.model.coordinates.map((c) => {
                someFeatures.push({
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [c.latlng[1], c.latlng[0]]
                    }
                })
            })

            const geojsonMarkerOptions = {
                radius: 4,
                fillColor: "#40826D",
                color: "#000",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8
            };

            L.geoJSON(someFeatures, {
                pointToLayer: function (feature, latlng) {
                    return L.circleMarker(latlng, geojsonMarkerOptions);
                }
            }).addTo(this.map);
        }
    }

    loadRoutes() {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
        this.gettingRoutes = true;
        return this.RouteService.getActiveRoutes(this.model.branch, formattedDate)
            .then((res) => {
                if (res.results.length) {
                    this.model.allRoutes = res.results;
                }
                else {
                    this.model.allRoutes = [];
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.gettingRoutes = false;
            })
    }

    getRouteStops() {
        this.model.routeStartTime = null;
        this.model.allRoutes.find((route) => {
            if (route.routeId == this.model.route && route.routeBeginTime) {
                const utcRouteTime = moment.utc(route.routeBeginTime, "HH:mm:ss");
                this.model.routeStartTime = utcRouteTime.tz(this.model.timezone).format();
            }
        })
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
        this.model.loading = true;
        this.lat = 0;
        this.long = 0;
        this.totalLatLongLocations = 0;
        this.stopsInfo = "";
        this.locationLatLong = [];

        this.RouteProgressService.getRouteStops(this.model.route, formattedDate, this.model.branch)
            .then((data) => {
                let routeProgressData = _.orderBy(data.results, ['completedTime'], ['asc']);
                this.model.routeStops = data.results;
                this.model.coordinates = data.coordinates;
                this.model.routeDetails = data.routeDetails;
                this.model.routeDetails.complTime = moment(this.model.routeDetails.complTime).utc(true).format('hh:mm a');

                this.model.routeStops.forEach((j) => {
                    routeProgressData.forEach((k, index) => {
                        if ((j.completedTime && k.completedTime) && (j.locationId == k.locationId)) {
                            j.stopProcessOrder = index + 1;
                        }
                    })
                })

                this.stopsInfo = data;
                if (this.model.routeStops.length) {
                    this.model.routeStops.forEach((data, index) => {
                        if (data.lat && data.long) {
                            this.locationLatLong.push(new Array(data.lat, data.long));
                            this.totalLatLongLocations += 1; // locations which had lat, long value counted as totalLatLongLocations
                            this.lat += data.lat; // sum of Lattitude value of location 
                            this.long += data.long; //  sum of Longitude value of location 
                        }
                    })
                }
                this.resetSorting();
                this.model.estimatedRouteMilage = {};
                this.model.estimatedRouteMilageError = null;
                this.checkCache();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                if (this.mapLoadingTimeout) {
                    clearTimeout(this.mapLoadingTimeout);
                }
                this.safeReloadMapContainer();
                this.mapLoadingTimeout = setTimeout(() => {
                    if (this.model.routeStops.length) {
                        this.loadMap(this.model.routeStops);
                        this.addBranchDetails();
                    }
                }, 100);
                this.stacked();
                this.resetRedirectionData();
                this.model.loading = false;
            })
    }

    reloadMapContainer() {
        this.map.remove();
        this.isInitialized = true;
        this.markerPosition.forEach((id) => {
            this.map.removeLayer(id)
        });
        this.markerPosition = [];
    }

    safeReloadMapContainer() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
        this.isInitialized = true;
        this.markerPosition = [];
    }

    resetData() {
        this.model.route = null;
        this.model.routeStops = [];
    }

    refreshData() {
        this.getRouteStops();
    }

    goToRouteTab() {
        const date = moment(this.model.date).format('YYYY-MM-DD');
        const obj = {
            routeId: this.model.route,
            vaultDate: date + 'T00:00:00.000Z',
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.routes');
    }

    goToItemHold(trackingId) {
        const obj = {
            trackingId: trackingId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.itemHolds');
    }

    getStopStatus(data) {
        if ((data && !data.stopStatus && !data.completedTime) || (data.stopStatus === 'PENDING')) return this.$translate.instant('routeProgress.pending');
        else if (data.completedTime && data.stopStatus === 'PARTIAL') return this.$translate.instant('routeProgress.partial');
        else if (data && data.stopStatus === 'DO') return this.$translate.instant('routeProgress.completed');
        // else if (data && data.stopStatus === 'CANT' && data.totalTransactionRecords === 0) return this.$translate.instant('routeProgress.cant');
        else if (data && data.stopStatus === 'CANT' && (data.totalTransactionRecords > 0 || data.totalTransactionRecords === 0)) return this.$translate.instant('routeProgress.cant').toUpperCase();
        else if (data.completedTime && data.stopStatus === 'NO_PICKUP') return this.$translate.instant('routeProgress.no_pickup');
        // else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.delivered_no_pickup');
        else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.completed_no_pickup');
        else if (data.completedTime && data.stopStatus === 'CRV') return this.$translate.instant('shipment.CRVed');
        else if (data.completedTime && data.stopStatus === 'NOT') return this.$translate.instant('routeProgress.not_worked');
        else return;
    }

    stacked() {
        this.stackData = [];
        let totalRemaining = 0;
        let totalDelivered = 0;
        let cantProcessed = 0;
        let notWorked = 0;
        // let CRVed = 0;

        this.model.routeStops.forEach((data) => {
            if (data && !data.stopStatus && !data.completedTime) totalRemaining++;
            else if (data && data.stopStatus === 'NOT') notWorked++;
            else if (data && data.stopStatus === 'DO') totalDelivered++;
            // else if (data && data.stopStatus === 'CRV') CRVed++;
            else if (data && (data.stopStatus === 'CANT' || data.stopStatus === 'PENDING' || data.stopStatus === 'PARTIAL' ||
                data.stopStatus === 'NO_PICKUP' || data.stopStatus === 'DELIVERED_NO_PICKUP' || data.stopStatus === 'CRV')) return cantProcessed++;
        })

        this.stackData.push({ value: totalRemaining, type: 'info' },
            { value: totalDelivered, type: 'success' },
            { value: notWorked, type: 'danger' },
            // { value: CRVed, type: 'warning' },
            { value: cantProcessed, type: 'warning' });
    };

    goToUserTab(id) {
        return this.Navigation.goToUserTab(id, null);
    }

    addBranchDetails() {
        let locationLat, locationLong, iconNumber, iconColor, locationInfo;
        const truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
        const userCoordinatesInfo = (this.stopsInfo.userCoordinatesInfo && this.stopsInfo.userCoordinatesInfo[0]) || {};
        const isUserOriginMismatch = userCoordinatesInfo.id && userCoordinatesInfo.userOrigin && userCoordinatesInfo.userOrigin !== 'USER';
        if (truckCoordinatesInfo.id) {
            locationLat = truckCoordinatesInfo.lat;
            locationLong = truckCoordinatesInfo.long;
            iconNumber = 'T';
            iconColor = 'black';
            locationInfo = '<strong>' + truckCoordinatesInfo.id + '</strong><br>' + truckCoordinatesInfo.address + ' - ' + truckCoordinatesInfo.zip +
                '<br>' + truckCoordinatesInfo.city + ', ' + truckCoordinatesInfo.state;
        } else if (userCoordinatesInfo.id && !isUserOriginMismatch) {
            locationLat = userCoordinatesInfo.lat;
            locationLong = userCoordinatesInfo.long;
            iconNumber = 'U';
            iconColor = 'black';
            locationInfo = '<strong>' + userCoordinatesInfo.id + '</strong><br>' + userCoordinatesInfo.address + ' - ' + userCoordinatesInfo.zip +
                '<br>' + userCoordinatesInfo.city + ', ' + userCoordinatesInfo.state;
        } else {
            locationLat = this.branchInfo.gpsLat;
            locationLong = this.branchInfo.gpsLong;
            iconNumber = 'B';
            iconColor = 'black';
            locationInfo = '<strong>' + this.branchInfo.branchId + '</strong><br>' + this.branchInfo.address + ' - ' + this.branchInfo.zip +
                '<br>' + this.branchInfo.city + ', ' + this.branchInfo.state;
        }
        const id = L.marker([locationLat, locationLong],
            {
                icon: new L.AwesomeNumberMarkers({
                    number: iconNumber,
                    markerColor: iconColor
                })
            })
            .addTo(this.map)
            .bindPopup(locationInfo)

        id.on('mouseover', function () {
            id.openPopup();
        });

        id.on('mouseout', function () {
            id.closePopup();
        });
    }

    goToServiceHistory(locationId) {
        return this.Navigation.goToServiceHistory(locationId, null, true, null)
    }

    sortData(column) {
        this.model.reverseSort = (this.model.sortColumn == column) ? !this.model.reverseSort : false;
        this.model.sortColumn = column;
    }

    resetSorting() {
        this.model.sortColumn = '_index';
        this.model.reverseSort = false;
        // this.getEstimatedRouteMilage();
    }

    getComments(data, comments) {
        const locationId = data.locationId;
        this.Modal.confirm({
            header: this.$translate.instant('common.comment') + ' | ' + locationId,
            message: comments,
            callback: (({
                modal
            }) => {
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                modal.close();
            }),
            buttons: ['routeSheet.close'],
            type: 'success'
        })
    }

    autoSetAndLoadData() {
        if (this.routeDataObj && this.routeDataObj.isRedirected) {
            this.model.date = this.DateUtil.convertToDate(this.routeDataObj.vaultDate);
            this.model.route = this.routeDataObj.routeId;
            this.getRouteStops();
        }
    }

    resetRedirectionData() {
        if (this.routeDataObj) {
            this.routeDataObj.isRedirected = false;
            this.routeDataObj = this.DataCounter.setData();
        }
    }

    stopCommentsModal(obj) {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
        this.Modal.stopComments(obj.routeId, formattedDate, obj.locationId, ({ modal }) => {
            modal.close();
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }
    
    redirectToHistoryTab(data) {
        if (data.totalPickupShipments == 0) return;

        if (data.totalPickupShipments > 1) {
            return this.$window.open(`/app/branch-management/locations-history?locationId=${data.locationId}`, '_blank');
        }
        else {
            return this.$window.open(`/app/branch-management/shipment-history/${data.pickupTrackingIds}`, '_blank');
        }
    }

    getMilagePayload() {
        if(this.model.routeDetails.arrTime) return;
        if(this.model.routeStops.length == 0) return;

        let stopsToSend;
        const allCompleted = this.model.routeStops.every(s => s.completedTime);
        if (!this.model.routeDetails.arrTime && allCompleted) {
            // only last stop
            const last = this.model.routeStops[this.model.routeStops.length - 1];
            stopsToSend = [{
                name: last.locationId,
                lat: last.lat,
                long: last.long,
                targetStopTime: last.targetStopTime
            }];
        } else {
            // your existing logic
            stopsToSend = this.model.routeStops
                .filter(item => !item.completedTime)
                .map(item => ({
                    name: item.locationId,
                    lat: item.lat,
                    long: item.long,
                    targetStopTime: item.targetStopTime
                }));
        }
        const tempRouteStops = angular.copy(this.model.routeStops);
        let startPoint;
        const routeStarted = !!this.model.routeDetails.leaveTime;
        const truckCoordinatesInfo = this.stopsInfo.truckCoordinatesInfo[0] || {};
        const userCoordinatesInfo = (this.stopsInfo.userCoordinatesInfo && this.stopsInfo.userCoordinatesInfo[0]) || {};
        const routeOrigination = this.model.routeDetails.origination || (truckCoordinatesInfo.id ? 'TRUCK' : userCoordinatesInfo.id ? 'USER' : 'BRANCH');
        const fallbackStartPoint = truckCoordinatesInfo.id ? {
            name: truckCoordinatesInfo.id,
            lat: truckCoordinatesInfo.lat,
            long: truckCoordinatesInfo.long,
            origination: 'TRUCK'
        } : userCoordinatesInfo.id ? {
            name: userCoordinatesInfo.id,
            lat: userCoordinatesInfo.lat,
            long: userCoordinatesInfo.long,
            origination: 'USER'
        } : {
            name: this.model.branch,
            lat: this.branchInfo.gpsLat,
            long: this.branchInfo.gpsLong,
            origination: 'BRANCH'
        };
        if (routeStarted) {
            const lastCompletedStop = tempRouteStops
                .slice()
                .reverse()
                .find(item => item.completedTime);

            if (lastCompletedStop) {
                startPoint = {
                    name: lastCompletedStop.locationId,
                    lat: lastCompletedStop.lat,
                    long: lastCompletedStop.long,
                    completedTime: lastCompletedStop.completedTime
                };
            } else {
                startPoint = fallbackStartPoint;
            }
        } else {
            startPoint = fallbackStartPoint;
        };

        return {
            branch: {
                name: this.model.branch,
                coords: {
                    lat: this.branchInfo.gpsLat,
                    long: this.branchInfo.gpsLong,
                },
            },
            stops: stopsToSend.filter(stop => stop.lat && stop.long),
            route: {
                name: this.model.route,
            },
            startPoint: {
                name: startPoint.name,
                lat: startPoint.lat,
                long: startPoint.long,
                origination: startPoint.origination || routeOrigination,
                completedTime: startPoint.completedTime || null
            },
            deliveryDate: moment(this.model.date).format('YYYY-MM-DD'),
            branchTimezone: this.branchInfo.timezone,
            totalStops: this.model.routeStops.length,
            completedStops: this.model.routeStops.filter(item => item.completedTime).length,
            isRouteProgress: true
        };
    }

    checkCache() {
        const payload = this.getMilagePayload();
        if (!payload || !payload.stops.length) return;
        payload.checkCacheOnly = true;
        this.RouteProgressService.getEstimatedRouteMileage(payload)
            .then((res) => {
                if (res && (res.results || res.data || res.routeAnalysis)) {
                    // Cache hit, process the data
                    this.handleMileageResponse(res);
                }
            })
            .catch((err) => {
                console.log('Error checking cache:', err);
            });
    }

    handleMileageResponse(res) {
        const mileageData = res.data ? res.data : (res.results ? res.results.data : res);
        this.model.estimatedRouteMilage = mileageData;

        let activeRoute = null;
        if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.ActiveRoutes && mileageData.routeAnalysis.ActiveRoutes.length > 0) {
            activeRoute = mileageData.routeAnalysis.ActiveRoutes[0];
        }

        let formattedTime = 'N/A';
        let totalDistance = 'N/A';
        
        if (activeRoute && activeRoute.Summary) {
            formattedTime = this.DateUtil.convertToTimeFormat(activeRoute.Summary.TotalTimeByHours);
            totalDistance = activeRoute.Summary.DistanceMiles;
        } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.routesSummary) {
            totalDistance = mileageData.routeAnalysis.routesSummary.TotalFleetDistanceMiles;
        } else if (mileageData && mileageData.routeAnalysis && mileageData.routeAnalysis.OverallSummary) {
            // Fallback for old format
            formattedTime = mileageData.routeAnalysis.OverallSummary.TotalTimeInService || this.DateUtil.convertToTimeFormat(mileageData.routeAnalysis.OverallSummary.TotalDurationHours);
            totalDistance = mileageData.routeAnalysis.OverallSummary.TotalDistanceMiles;
        }

        if (this.model.estimatedRouteMilage && this.model.estimatedRouteMilage.routeAnalysis) {
             this.model.estimatedRouteMilage.routeAnalysis.OverallSummary = {
                 TotalTimeInService: formattedTime,
                 TotalDistanceMiles: totalDistance
             };
        }

        this.model.routeStops.forEach((stop) => {
            let stopDuration = null;
            if (activeRoute && activeRoute.Schedule) {
                stopDuration = activeRoute.Schedule.find((item) => item.ShipmentLabel == stop.locationId);
            } else if (this.model.estimatedRouteMilage && this.model.estimatedRouteMilage.routeAnalysis && this.model.estimatedRouteMilage.routeAnalysis.Schedule) {
                // Fallback for old format
                stopDuration = this.model.estimatedRouteMilage.routeAnalysis.Schedule.find((item) => item.ShipmentLabel == stop.locationId);
            }

            if(!stopDuration) {
                stop.estimatedTimeArrival = null;
                stop.StopNumber = "End";
            } else {
                stop.estimatedTimeArrival = stopDuration.ScheduledStartTime;
                stop.StopNumber = stopDuration.StopNumber;
            }
        });

        this.model.routeStops.sort((a, b) => {
            if (a.completedTime && !b.completedTime) return -1;
            if (!a.completedTime && b.completedTime) return 1;

            if (a.StopNumber === 'End') return 1;
            if (b.StopNumber === 'End') return -1;
            return a.StopNumber - b.StopNumber;
        });

        this.model.routeStops.forEach((stop, index) => {
            stop._index = index + 1;
        });

        if (this.mapLoadingTimeout) {
            clearTimeout(this.mapLoadingTimeout);
        }
        this.safeReloadMapContainer();
        this.mapLoadingTimeout = setTimeout(() => {

            if (this.model.routeStops.length) {
                this.loadMap(this.model.routeStops);
                this.addBranchDetails();
            }
        }, 100);
        this.stacked();
        this.resetRedirectionData();
        this.model.loading = false;
        this.model.estimatedRouteMilageLoading = false;
    }

    getEstimatedRouteMilage() {
        if(this.model.routeDetails.arrTime) return;
        if(this.model.routeStops.length == 0) {
            if(this.model.estimatedRouteMilage && this.model.estimatedRouteMilage.routeAnalysis && this.model.estimatedRouteMilage.routeAnalysis.OverallSummary) {
                this.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalTimeInService = 'N/A';
                this.model.estimatedRouteMilage.routeAnalysis.OverallSummary.TotalDistanceMiles = 'N/A';
            }
            this.model.estimatedRouteMilageLoading = false;
            this.model.loading = false;
            return;
        };
        this.model.estimatedRouteMilageLoading = true;

        const payload = this.getMilagePayload();
        if (!payload) {
            this.model.estimatedRouteMilageLoading = false;
            return;
        }
        this.RouteProgressService.getEstimatedRouteMileage(payload)
            .then((res) => {
                this.handleMileageResponse(res);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.model.estimatedRouteMilageError = err.data.message ? err.data.message : 'Get Estimated Route Mileage Error';
                }
                this.model.loading = false;
                this.model.estimatedRouteMilageLoading = false;
            });
    }
    
    getRouteEditDay() {
        return this.model.date ? moment(this.model.date).format('ddd') : '';
    }

    calculateTotalTime(arriveTime, leaveTime) {
        const arriveDate = moment(arriveTime);
        const leaveDate = moment(leaveTime);

        const duration = moment.duration(arriveDate.diff(leaveDate));

        const hours = duration.asHours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        
        return `${Number(hours).toFixed(0)} hours, ${Number(minutes).toFixed(0)} minutes, ${Number(seconds).toFixed(0)} seconds`;
    }

    formatMiles(miles) {
        if (!miles) return 0;
        return parseFloat(miles).toLocaleString() || 0;
    }
}

export default RouteProgressController;



// WEBPACK FOOTER //
// ./client/app/components/route_progress/route_progress.controller.js